<div class="container-fluid p-0 bg-light-gray">
  <div class="row m-0">
    <div class="col-12 p-0 bg-primary-white">
      <app-navbar></app-navbar>
      <div class="px-4 py-4">
        <div class="fs-5 text-secondary-purple mb-4">
          {{ 'app.personalInfo.title' | translate }}
        </div>
        <div class="card shadow-sm border-0 rounded-3">
          <div class="card-body px-4 py-4">
            <div class="row g-4">
              <div class="col-12 col-md-6">
                <label class="form-label text-secondary mb-1 small">{{ 'app.personalInfo.name' | translate }}</label>
                <div class="fs-6 fw-medium">{{ displayName() }}</div>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label text-secondary mb-1 small">{{ 'app.personalInfo.mobile' | translate }}</label>
                <div class="fs-6 fw-medium">{{ user?.mobile ?? '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label text-secondary mb-1 small">{{ 'app.personalInfo.dateOfBirth' | translate }}</label>
                <div class="fs-6 fw-medium">{{ user?.birth ?? '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label text-secondary mb-1 small">{{ 'app.personalInfo.joinDate' | translate }}</label>
                <div class="fs-6 fw-medium">{{ joinDate() | myDate:false:'yyyy-MM-dd' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label text-secondary mb-1 small">{{ 'app.personalInfo.emergencyName' | translate }}</label>
                <div class="fs-6 fw-medium">{{ user?.emergency_name ?? '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label text-secondary mb-1 small">{{ 'app.personalInfo.emergencyMobile' | translate }}</label>
                <div class="fs-6 fw-medium">{{ user?.emergency_mobile ?? '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label text-secondary mb-1 small">{{ 'app.personalInfo.grade' | translate }}</label>
                <div class="fs-6 fw-medium">{{ user?.type ?? '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
